import { RestResponse, TRestErrorHandler } from "@oceanjs/core";
import { SpringRestConfig } from "../SpringRestConfig";
import { KomponenteDto, ComponentDeleteDto, KomponenteCreateDto, ComponentDuplicates } from "../dto";
import { ComponentReleasesDto } from "../dto/ComponentReleasesDto";
import { EhpcBaseRestApi } from "../EhpcBaseRestApi";

const resource = SpringRestConfig.services.komponente;
/**
 *
 */
class KomponenteServiceApiImpl extends EhpcBaseRestApi {


  public async createKomponente(values: KomponenteCreateDto, onError?: TRestErrorHandler): Promise<RestResponse<KomponenteDto>> {
    const result = this.request<KomponenteDto>('post', resource, onError, values);
    return result;
  }

  public async editKomponente(id: number, dto: KomponenteCreateDto, onError?: TRestErrorHandler): Promise<RestResponse<KomponenteDto>> {
    const result = this.putCustomEndpoint<KomponenteDto, KomponenteCreateDto>(`${id}`, dto, undefined, onError);
    return result;
  }

  public async releaseKomponente(releases: ComponentReleasesDto, onError?: TRestErrorHandler): Promise<RestResponse<ComponentReleasesDto>> {
    const result = this.postCustomEndpoint<ComponentReleasesDto, ComponentReleasesDto>(`release`, releases, undefined, onError);
    return result;

  }
  public async deleteKomponente(type: string, id: number, dto: ComponentDeleteDto, onError?: TRestErrorHandler): Promise<RestResponse<void>> {
    // @ts-ignore { validateStatus: false }
    const result = this.postCustomEndpoint<void,ComponentDeleteDto>(`${type}/${id}/delete`, dto, undefined, onError );
    return result;
  }

  public async checkKomponenteDuplikate(dto: KomponenteCreateDto, onError?: TRestErrorHandler): Promise<RestResponse<ComponentDuplicates>> {
    const result = this.postCustomEndpoint<ComponentDuplicates,KomponenteCreateDto>(`duplicates`,dto, undefined, onError);
    return result;
    
  }

}

export const KomponenteServiceApi = new KomponenteServiceApiImpl(resource);
